interface PageInfoHeadingProps {
  icon?: React.ReactNode;
  text: string | React.ReactNode;
}

export const PageInfoHeading = ({ icon, text }: PageInfoHeadingProps) => {
  return (
    <div className="flex gap-2">
      {icon && (
        <div className="flex justify-center items-center -mt-0.5">{icon}</div>
      )}
      <div className="flex items-center">
        <p className="text-gray-78819D text-sm">{text}</p>
      </div>
    </div>
  );
};
